<button matSuffix mat-icon-button aria-label="Clear" (click)="openFilterPanel()">
    <mat-icon>tune</mat-icon>
</button>
